<template>
  <div class="mini-calendar__filters">
    <MiniCalendarCalendar />
    <div class="mini-calendar__filters-form" v-if="show_submit_event">
      <a :href="submit_event_url" target="_blank" class="mini-calendar__button mini-calendar__event-link submit-event-button" >{{ submit_event_title ? submit_event_title : 'Submit Event' }} <IconSubmit /></a>
    </div>
    <MiniCalendarCollpase :title="date_filter.title" :categories="date_filter.list" option="radio"/>
    <template v-if="categorylist.keys ? categorylist.keys : []">
      <MiniCalendarCollpase v-for="item in categorylist.keys" :key="item" :title="categorylist.data[item].title " :categories="categorylist.data[item].terms" />
    </template>
  </div>
</template>

<script>
import MiniCalendarCalendar from "./mini-calendar-calendar.vue"
import MiniCalendarCollpase from "./collapse/mini-calendar-collapse"
import { DATE_FILTER } from "@/utils/config";
import { mapGetters } from 'vuex'
import IconSubmit from './icon/icon-submit-event.vue'

export default {
  name: 'MiniCalenderFilters',
  components: {
    MiniCalendarCalendar,
    MiniCalendarCollpase,
    IconSubmit,
  },
  computed: {
    ...mapGetters(['categorylist'])
  },
  data() {
    return {
      date_filter: DATE_FILTER,
      show_submit_event: window.drupalSettings.idfive_calendar_client.options.show_submit_event != 0 ? true : false,
      submit_event_title: window.drupalSettings.idfive_calendar_client.options.submit_event_title,
      submit_event_url: window.drupalSettings.idfive_calendar_client.options.submit_event_url,
    }
  }
}
</script>

<style lang="scss">
  .mini-calendar__filters {
    width: 100%;
    order: 0;
    padding-left: rem(30);
    padding-right: rem(30);

    @include tablet-up {
      flex: 0 1 auto;
      width: 40%;
      order: 1;
      padding-left: 0;
      padding-right: 0;
    }

    @include desktop-xl-up {
      width: 30%;
    }

    &-form {
      border-top: 1px solid $border-color2;
      padding-top: rem(20);

      .mini-calendar__event-link {
        width: 100%;
        font-size: rem(22);
        margin: 0;
      }
    }
  }
</style>